import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'common/spinners';
import _ from 'lodash';
import { Icon } from '@unite-us/app-components';
// import { pluralize } from 'humanize-plus';
import './PaginationLoader.scss';

function hasMorePages(pagingObject) {
  return pagingObject.next_page;
}

function morePagesText(/* pagingObject */) {
  // const remainingResults = //TODO: commented because CW-144
  //   pagingObject.total_count - pagingObject.current_page * pagingObject.per;
  // return remainingResults >= pagingObject.per ?
  //   `See ${pagingObject.per} more results` :
  //   `See ${remainingResults} more ${pluralize(remainingResults, 'result')}`;
  return 'See more results';
}

const PaginationLoader = ({
  appendData,
  emptyMessage,
  isFetching,
  paging,
  serviceAreaSupportForOrgsFlag,
}) => {
  if (isFetching) {
    return <Spinner />;
  }
  console.log('Pagination LOADER');
  if (hasMorePages(paging) && !_.isEmpty(paging)) {
    return (
      <a
        className={serviceAreaSupportForOrgsFlag ? 'group_list_more_results' : 'detail-load'}
        onClick={appendData} role="button"
      >
        {serviceAreaSupportForOrgsFlag ?
          (
            <>
              {morePagesText()}
              <Icon
                className="ml-1.5"
                icon="ChevronArrow"
                direction="right"
                color="action-blue"
                size={11}
              />
            </>
          ) : <small>Load More</small>}
      </a>
    );
  }

  return _.isString(emptyMessage) ? <p>{emptyMessage}</p> : emptyMessage;
};

PaginationLoader.propTypes = {
  appendData: PropTypes.func.isRequired,
  emptyMessage: PropTypes.node,
  isFetching: PropTypes.bool.isRequired,
  paging: PropTypes.object.isRequired,
  serviceAreaSupportForOrgsFlag: PropTypes.bool,
};

PaginationLoader.defaultProps = {
  emptyMessage: 'No More Results',
  isFetching: false,
  paging: {},
  serviceAreaSupportForOrgsFlag: false,
};

export default PaginationLoader;
